// Analytics event parameters interface
export interface AnalyticsEvent {
  event_category?: string
  event_label?: string
  value?: number
  page_location?: string
  page_title?: string
  [key: string]: unknown
}

// Composable for Google Analytics tracking
export function useAnalytics() {
  // Base function to track any event
  const trackEvent = (eventName: string, parameters: AnalyticsEvent = {}) => {
    // Check if gtag is available
    if (typeof gtag === 'undefined') {
      console.warn('Google Analytics not loaded')
      return
    }

    // Add default parameters
    const eventParams = {
      ...parameters,
      page_location: parameters.page_location ?? window.location.href,
      page_title: parameters.page_title ?? document.title,
    }

    gtag('event', eventName, eventParams)
  }

  // Specific tracking function for spin events
  const trackSpin = () => {
    trackEvent('spin', {
      event_category: 'game',
      event_label: 'wheel_spin',
    })
  }

  // Track wallet connection
  const trackWalletConnect = (location: string) => {
    trackEvent('wallet_connect', {
      event_category: 'wallet',
      event_label: location,
    })
  }

  // Track buy SPOTTY button clicks
  const trackBuySpotty = (location: string) => {
    trackEvent('buy_spotty', {
      event_category: 'purchase',
      event_label: location,
    })
  }

  // Track social media button clicks
  const trackSocialClick = (platform: string, location: string) => {
    trackEvent('social_click', {
      event_category: 'social',
      event_label: `${platform}_${location}`,
    })
  }

  return {
    trackEvent,
    trackSpin,
    trackWalletConnect,
    trackBuySpotty,
    trackSocialClick,
  }
}
